/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordCountsResponseData } from "./RecordCountsResponseData";
export const RecordCountsResponse = core.serialization.object({
    data: RecordCountsResponseData,
});
